'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagTjAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 5.54323e-06C9.33333 -5.22355e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V5.54323e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 6.66667H28V0L0 5.54323e-06V6.66667Z",
          fill: "#D9101C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0V20Z",
          fill: "#0F7811"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.3333 8.66667C13.3333 9.03486 13.0349 9.33333 12.6667 9.33333C12.2985 9.33333 12 9.03486 12 8.66667C12 8.29848 12.2985 8 12.6667 8C13.0349 8 13.3333 8.29848 13.3333 8.66667Z",
          fill: "#FAD14E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.6667 10C14.6667 10.1206 14.6347 10.3767 14.5787 10.6667H15.3333C15.7015 10.6667 16 10.9651 16 11.3333C16 11.7015 15.7015 12 15.3333 12H12.6667C12.2985 12 12 11.7015 12 11.3333C12 10.9651 12.2985 10.6667 12.6667 10.6667H13.4213C13.3653 10.3767 13.3333 10.1206 13.3333 10C13.3333 9.63181 13.6318 9.33333 14 9.33333C14.3682 9.33333 14.6667 9.63181 14.6667 10Z",
          fill: "#FAD14E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16 8.66667C16 9.03486 15.7015 9.33333 15.3333 9.33333C14.9651 9.33333 14.6667 9.03486 14.6667 8.66667C14.6667 8.29848 14.9651 8 15.3333 8C15.7015 8 16 8.29848 16 8.66667Z",
          fill: "#FAD14E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18 10.6667C18.3682 10.6667 18.6667 10.3682 18.6667 10C18.6667 9.63181 18.3682 9.33333 18 9.33333C17.6318 9.33333 17.3333 9.63181 17.3333 10C17.3333 10.3682 17.6318 10.6667 18 10.6667Z",
          fill: "#FAD14E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.6667 10C10.6667 10.3682 10.3682 10.6667 10 10.6667C9.63181 10.6667 9.33333 10.3682 9.33333 10C9.33333 9.63181 9.63181 9.33333 10 9.33333C10.3682 9.33333 10.6667 9.63181 10.6667 10Z",
          fill: "#FAD14E"
        }
      )
    ]
  }
);
const VpFlagTjAsset = forwardRef(FlagTjAsset);

export { VpFlagTjAsset as default };
